import React from 'react';
import { Helmet } from 'react-helmet';
interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
}
export function SEO({
  title = 'HomeLinkPro – Smart Tools for Daily Business Management',
  description = 'HomeLinkPro provides cloud-based tools for scheduling work, sharing files and collaborating in real time. Simple, secure and organised.',
  keywords = 'business management, cloud tools, team collaboration, file sharing, task scheduling, UK business software'
}: SEOProps) {
  return <Helmet data-id="element-224">
      <title data-id="element-225">{title}</title>
      <meta name="description" content={description} data-id="element-226" />
      <meta name="keywords" content={keywords} data-id="element-227" />
      <meta property="og:title" content={title} data-id="element-228" />
      <meta property="og:description" content={description} data-id="element-229" />
      <meta property="og:type" content="website" data-id="element-230" />
      <meta name="twitter:card" content="summary_large_image" data-id="element-231" />
      <meta name="twitter:title" content={title} data-id="element-232" />
      <meta name="twitter:description" content={description} data-id="element-233" />
    </Helmet>;
}